<template>
    <div class="mb-8 space-y-2 max-w-7xl mx-auto">
        <div class="flex items-center justify-between bg-gray-50 py-2 px-3">
            <h4 class="text-lg text-center font-medium">{{ $t('Thanks Cards') }}</h4>
        </div>

        <ul class="space-y-1">
            <li v-for="thanksCard in posts" :key="thanksCard.id">
                <ThanksCard :thanksCard="thanksCard" />
            </li>
        </ul>

        <spinner v-if="!posts && loading" />
        <div v-else>
            <div v-if="hasMore" class="flex justify-center">
                <button
                    @click="showMore"
                    class="border flex justify-center items-center h-10 w-40 border-gray-400 hover:border-gray-800 text-sm rounded px-3 py-2"
                >
                    <spinner v-if="loadingMore" class="text-white" />
                    <span v-else>{{ $t('Load More') }}</span>
                </button>
            </div>
            <div v-else class="flex justify-center">
                <span>{{ $t('No more items to show') }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../lib/api'
import ThanksCard from '../components/ThanksCard'

export default {
    components: {
        ThanksCard,
    },
    methods: {
        async showMore() {
            this.loadingMore = true
            const [morePosts, newOffset] = await api.getPosts(this.limit, this.offset)
            this.posts = [...this.posts, ...morePosts]
            this.offset = newOffset
            this.loadingMore = false
        },
    },
    data() {
        return {
            loading: true,
            posts: null,
            loadingMore: false,
            limit: 10,
            offset: null,
            hasMore: true,
        }
    },
    async mounted() {
        if (this.$route.query.reload === true) {
            /* this.$apollo.queries.thanksCards.refetch() */
            this.$router.push('/thanks-cards')
        }
        const [posts, newOffset] = await api.getPosts(this.limit, null)
        this.posts = posts
        this.offset = newOffset
        this.loading = false
    },
}
</script>
